import { ReactElement } from 'react';
import cc from 'classcat';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { isMobile } from 'utils/is-mobile';
import { CounterStrikeStatisticsScoresSkeleton } from './CounterStrikeStatisticsScoresSkeleton';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';
import '../index.less';

type TCounterStrikeStatisticsSkeletonProps = {
  className?: string;
};

export const CounterStrikeStatisticsSkeleton = ({
  className = ''
}: TCounterStrikeStatisticsSkeletonProps): ReactElement => {
  return (
    <div
      className={cc(['counterStrike__statistics', { [className]: className }])}
    >
      <div
        className={cc([
          'counterStrike__statistics-row counterStrike__statistics-row-team-names-skeleton',
          {
            'team-names': !isMobile(),
            'team-names--mobile': isMobile(),
            'counterStrike__statistics-row--withoutTeamLogo':
              !SpringConfigs.TEAM_LOGOS
          }
        ])}
      >
        <div className="counterStrike__statistics-row team-info">
          {SpringConfigs.TEAM_LOGOS && (
            <span className="counterStrike__statistics-column team-logo">
              <Skeleton.Avatar
                size="small"
                active
                style={{ width: 32, height: 32 }}
                shape="circle"
              />
            </span>
          )}
          {!isMobile() && (
            <span className="counterStrike__statistics-column team-name">
              <Skeleton.Input active size="small" />
            </span>
          )}
        </div>

        <div className="counterStrike__statistics-row team-info">
          {SpringConfigs.TEAM_LOGOS && (
            <span className="counterStrike__statistics-column team-logo">
              <Skeleton.Avatar
                size="small"
                active
                style={{ width: 32, height: 32 }}
                shape="circle"
              />
            </span>
          )}
          {!isMobile() && (
            <span className="counterStrike__statistics-column team-name">
              <Skeleton.Input active size="small" />
            </span>
          )}
        </div>
      </div>
      <CounterStrikeStatisticsScoresSkeleton />
    </div>
  );
};
